<template>
  <router-view></router-view>
</template>
<script>
    export default {
        name: 'app',
        created () {
            document.title = "Negiranje Genocida";
        }
    }
</script>
